import { Icon, IconProps } from './Icon';

export type NavigationPointerProps = IconProps;

export const NavigationPointer = (props: NavigationPointerProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M2.276 7.163c-.397-.154-.596-.232-.654-.343a.333.333 0 0 1 0-.307c.058-.112.256-.19.653-.344l11.258-4.393c.359-.14.538-.21.652-.172.1.033.178.111.21.21.039.115-.031.294-.17.652L9.83 13.725c-.155.396-.233.595-.344.653a.333.333 0 0 1-.308 0c-.11-.059-.188-.257-.342-.654L7.085 9.22c-.032-.08-.047-.121-.072-.155a.333.333 0 0 0-.077-.078.717.717 0 0 0-.155-.07L2.276 7.162Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
